<template>
  <div>
  
     <Modal
            :mask-closable="false"
            v-model="setHeigthObj.setHeigthModal"
            title="升高计划表设置"
            :footerHide="true"
            width="600"
            @on-cancel="setHeigthModalcancel"
           
        >
        <Form  ref="formValiEditHeight" :model="formValiEditHeight" :rules="ruleValidateHeight" :label-width="90" >
          <Button type="info" @click="handleAdd" icon="md-add">添加分项成绩</Button><span style="color:#ccc;">（&nbsp;成绩值以厘米为单位&nbsp;）</span>
          <div class="cf heightList">
                  <FormItem
                          class="float-l"
                          v-for="(item, k) in formValiEditHeight.details"
                          v-if="item.status"
                          :key="k"
                          :label="'高度' + (k+1) +'：'"
                          :prop="'details.' + k + '.hight'"
                          :rules="{required: true, message: '只能为数字类型', trigger: 'blur',pattern:/^(([1-9]\d{0,5})|0)(\.\d{0,5})?$/}">
                          <div>
                              <Input :maxlength="6" type="text" class="width70PX m-r10px" v-model="item.hight" placeholder="成绩"  ></Input>
                              <Button   icon="ios-trash" @click="handleRemove(k)">删除</Button>
                          </div>
                  </FormItem>
          </div>
          <div class="UpBut">
              <Button type="primary" size="large" :disabled="disableds"   @click="setHieghtSubmit('formValiEditHeight')">保存</Button>
          </div>
        </Form>
    </Modal>

  </div>
</template>

<script>
import {addHighincrease,getHighincrease} from '@/lib/api/index.js'


export default { 
  /*
    allProp判断如果是全能的选手就不需要名次字段 
    group判断是否为综合成绩
    childTitle传给查看运动员项目的标题
  */
  props: ['setHeigthObj'],
  data () {
    return {
      formValiEditHeight:{
        details:[]
      },
      ruleValidateHeight:{

      },
      index:0,
      disableds:false,
    }
  },
  watch: {
    setHeigthModal()
    {
        let data =  {
            sexSortEventID:this.setHeigthObj.sexSortEventID,
            layer:this.setHeigthObj.layer
        }
        this.setHeigthModalcancel();
        if(this.setHeigthObj.setHeigthModal)
        {
            getHighincrease(data).then(res => {
              if(res.data.code == 0){
                for(let item of res.data.data)
                {
                  this.index++;
                  this.formValiEditHeight.details.push({
                    hight:item.hight,
                    status:1,
                  })
                }
                console.log(this.index)
                this.$emit('resultUp');
              }else if(res.data.code == -2){
                  this.$Message.error("获取失败");
              }else if(res.data.code==10)
              {
                  this.$Message.info("登录token过期请重新登录");
                  this.$store.dispatch('loginOut');
              }else{
                  this.$Message.error(res.data.msg);
              }
          },err =>{
              this.$Message.error("网络连接失败");
          });
        }
        
    }
  },
  computed: {
   setHeigthModal()
   {
     return this.setHeigthObj.setHeigthModal;
   }
  },
  components: {
  }
  ,
  methods: {
  
    setHeigthModalcancel()
    {
          this.formValiEditHeight = {
            details:[]
          };
          this.index = 0;
    },
    handleRemove (index) {
            let _index = this.index-1;
            if(this.formValiEditHeight.details.length)
            {
                this.formValiEditHeight.details[index].status = 0;
                this.formValiEditHeight.details.splice(index,1);
            }
            
            this.index-=1;
            
    },
    handleAdd()
    {
        let all = true;
        if(this.index<30)
        {
            this.index++;
        }else{
            all = false;
        }
        if(all)
        {
            this.formValiEditHeight.details.push({
                hight: '',
                status: 1,
            });
        }
    },
    setHieghtSubmit(name)
    {
      this.$refs[name].validate((valid) => { 
          if (valid) {
              this.disableds = true;
              let heightList = [];
              for(let tiem of this.formValiEditHeight.details)
              {
                heightList.push({
                  SexSortEventID:this.setHeigthObj.sexSortEventID,
                  hight:tiem.hight,
                  gameId:this.setHeigthObj.gameId,
                  layer:this.setHeigthObj.layer
                });
              }
              this.loadings();
              addHighincrease(heightList).then( (res) => {
                  if(res.data.code==0)
                  {
                      this.$Message.info("添加成功");
                      this.handleReset('formValiEditHeight');
                      this.disableds = false;
                      this.formValiEditHeight.details = [];
                      this.$emit('setHeigthModalShow');
                      
                      this.index = 0;
                      this.$Spin.hide();
                  }else if(res.data.code == -2){
                      this.$Message.error("获取失败");
                      this.$Spin.hide();
                  }else if(res.data.code==10)
                  {
                      this.$Message.info("登录token过期请重新登录");
                      this.$store.dispatch('loginOut');
                  }else{
                      this.$Message.error(res.data.msg);
                      this.$Spin.hide();
                  }
              
              }).catch((error) => {
              })
          }
      })
    }
  },
  created () {
    
  },
  mounted () {
    
  }
}
</script>
<style scoped>
.heightList{padding: 32px 0;}
</style>



// WEBPACK FOOTER //
// src/components/setHeigth.vue